<template>
  <div>
    <bread :data="bread" />

    <el-form size="mini" :inline="true">
      <el-form-item label="登录名">
        <el-input v-model="searchData.loginName" placeholder="请输入登录名"></el-input>
      </el-form-item>
      <!-- <el-form-item label="部门">
        <el-select v-model="searchData.officeId" placeholder="请选择部门">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="init()">查询</el-button>
      </el-form-item>
    </el-form>

    <cesTable
      size="mini"
      :isSelection="false"
      :isIndex="true"
      :isPagination="true"
      :loading="false"
      :isHandle="true"
      :tableData="tableData"
      :tableCols="tableCols"
      :tableHandles="tableHandles"
      :pagination="pagination"
      @refresh="init"
    />

    <userAdd ref="userAdd" :title="title" />
  </div>
</template>
    <!-- 用户管理 -->
<script>
import bread from "@/components/Module/Bread";
import cesTable from "@/components/Module/Table";
import userAdd from "./Module/User/UserAdd";

import {
  userListApi,
  userDelApi,
  resetPwdApi,
  officeListApi
} from "@/api/api";

export default {
  name: "",
  data() {
    return {
      bread: [
        {
          link: "",
          name: "首页"
        },
        {
          link: "",
          name: "系统管理"
        },
        {
          link: "",
          name: "用户管理"
        }
      ],
      searchData: {
        loginName: "",
        officeId: ""
      },
      options:[],
      tableData: [],
      tableCols: [
        { label: "登录名", prop: "loginName" },
        { label: "手机号码", prop: "mobile" },
        { label: "创建时间", prop: "createDate" },
        {
          label: "操作",
          type: "Button",
          width: "250px",
          btnList: [
            { label: "修改", handle: (row, i) => this.update(row, i) },
            {
              type: "danger",
              label: "删除",
              handle: (row, i) => this.del(row, i)
            }
          ]
        }
      ],
      tableHandles: [
        { label: "新增", type: "primary", handle: row => this.add() }
      ],
      pagination: {
        pageSize: 15,
        pageNum: 1,
        total: 0
      },
      title: ""
    };
  },
  methods: {
    async update(v, i) {
      this.title = "修改用户";
      this.$refs.userAdd.init(v);
    },
    del(v, i) {
      let { id } = v;
      let { init } = this;
      elMsgBox("您确定要删除这个用户吗？", "del").then(res => {
        userDelApi(id).then(res => {
          elMsg("删除成功");
          init();
        });
      });
    },
    async add() {
      this.title = "新增用户";
      this.$refs.userAdd.init();
    },
    resetPass(v, i) {
      let { id } = v;
      elMsgBox("您确定要重置该用户密码吗？", "warning").then(res => {
        resetPwdApi(id).then(res => {
          elMsg("重置成功");
        });
      });
    },
    init() {
      let {
        pagination: { pageSize, pageNum },
        searchData: { loginName = "", officeId = "" }
      } = this;
      userListApi({
        loginName: loginName,
        officeId: officeId,
        "page.current": pageNum,
        "page.pageSize": pageSize
      })
        .then(res => {
          this.tableData = res.list;
          this.pagination.total = parseInt(res.total);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getOfficeList() {
      officeListApi().then(res => {
        this.options = res;
      });
    }
  },
  created() {
    this.init();
    this.getOfficeList();
  },
  components: {
    bread,
    cesTable,
    userAdd
  }
};
</script>

<style lang='less' scoped>
</style>